import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, isEmpty, map} from "lodash"

import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import withRewardOnChange from "./withRewardOnChange"

export const schema = (required = false) =>
  Validation.array(required ? "This field is required" : null).of(
    Validation.object().shape({
      value: Validation.string()
    })
  )

const PROPERTY = "tagIds"

class Tags extends Component {
  static propTypes = {
    required: PropTypes.bool,
    reward: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    tags: PropTypes.array.isRequired
  }

  static defaultProps = {
    id: "tags",
    required: false,
    label: "",
    hint: "Start typing to find tags.",
    tags: [],
    onChange: null
  }

  getTags = () => {
    const {tags} = this.props
    const tagUuids = this.getSelectedTags()
    return tags.filter((tag) => {
      return tagUuids.includes(tag.uuid) ? tag : null
    })
  }

  getSelectedTags = () => {
    return get(this.props.reward, PROPERTY) ? get(this.props.reward, PROPERTY) : []
  }

  handleChange = (selectedTags) => {
    const {reward, onChange} = this.props
    const tags = map(selectedTags, "value")

    onChange(reward, PROPERTY, isEmpty(selectedTags) ? [] : tags)
  }

  render() {
    const {tags, onChange, reward, label, required, ...props} = this.props

    return (
      <Select
        {...props}
        isMulti
        name={PROPERTY}
        id={id(PROPERTY, props)}
        label={`${label}${required ? "*" : ""}`}
        value={this.getTags().map((tag) => ({value: tag.uuid, label: tag.name}))}
        menuShouldScrollIntoView={false}
        validation={schema(required)}
        onChange={this.handleChange}
        options={tags.map((tag) => ({value: tag.uuid, label: tag.name}))} />
    )
  }
}

export default withRewardOnChange(Tags)
